export const LINE_COLORS: Record<string, string> = {
  RD: '#E51636',
  OR: '#F68712',
  YL: '#FFD100',
  GR: '#00B140',
  BL: '#0077C8',
  SV: '#91999F',
};

export const LINE_NAMES: Record<string, string> = {
  RD: 'Red',
  OR: 'Orange',
  YL: 'Yellow',
  GR: 'Green',
  BL: 'Blue',
  SV: 'Silver',
};

export const LINE_ABBREVS: Record<string, string> = {
  Red: 'RD',
  Orange: 'OR',
  Yellow: 'YL',
  Green: 'GR',
  Blue: 'BL',
  Silver: 'SV',
};

export const MAP_CENTER: [number, number] = [-77.0369, 38.9072];
export const MAP_ZOOM = 11.5;

export const MAP_STYLE_LIGHT = 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json';
export const MAP_STYLE_DARK = 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json';
